var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "entryDesign" }, [
    _c("div", { staticClass: "formTitle" }, [_vm._v("作品信息")]),
    _vm._v(" "),
    _c("div", { staticClass: "designInfo" }, [
      _c(
        "div",
        { staticClass: "infoItem" },
        [
          _c("span", { staticClass: "labelSpan" }, [_vm._v("作品/课程名称：")]),
          _vm._v(" "),
          _c("el-tooltip", { attrs: { placement: "top" } }, [
            _c("div", { attrs: { slot: "content" }, slot: "content" }, [
              _vm._v(_vm._s(_vm.worksInfo.workName)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "valSpan" }, [
              _vm._v(_vm._s(_vm.worksInfo.workName)),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "infoItem" },
        [
          _c("span", { staticClass: "labelSpan" }, [_vm._v("所属学校：")]),
          _vm._v(" "),
          _c("el-tooltip", { attrs: { placement: "top" } }, [
            _c("div", { attrs: { slot: "content" }, slot: "content" }, [
              _vm._v(_vm._s(_vm.worksInfo.schoolName)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "valSpan" }, [
              _vm._v(_vm._s(_vm.worksInfo.schoolName)),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "infoItem" },
        [
          _c("span", { staticClass: "labelSpan" }, [_vm._v("所属组别：")]),
          _vm._v(" "),
          _c("el-tooltip", { attrs: { placement: "top" } }, [
            _c("div", { attrs: { slot: "content" }, slot: "content" }, [
              _vm._v(_vm._s(_vm.worksInfo.groupName)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "valSpan" }, [
              _vm._v(_vm._s(_vm.worksInfo.groupName)),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "infoItem" },
        [
          _c("span", { staticClass: "labelSpan" }, [_vm._v("审核状态：")]),
          _vm._v(" "),
          _c("el-tooltip", { attrs: { placement: "top" } }, [
            _c("div", { attrs: { slot: "content" }, slot: "content" }, [
              _vm._v(_vm._s(_vm._f("getStatus")(_vm.worksInfo.status))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "valSpan" }, [
              _vm._v(_vm._s(_vm._f("getStatus")(_vm.worksInfo.status))),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "infoItem" },
        [
          _c("span", { staticClass: "labelSpan" }, [_vm._v("审核专家：")]),
          _vm._v(" "),
          _c("el-tooltip", { attrs: { placement: "top" } }, [
            _c("div", { attrs: { slot: "content" }, slot: "content" }, [
              _vm._v(_vm._s(_vm.worksInfo.experts)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "valSpan" }, [
              _vm._v(_vm._s(_vm.worksInfo.experts)),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "infoItem" },
        [
          _c("span", { staticClass: "labelSpan" }, [_vm._v("最终得分：")]),
          _vm._v(" "),
          _c("el-tooltip", { attrs: { placement: "top" } }, [
            _c("div", { attrs: { slot: "content" }, slot: "content" }, [
              _vm._v(_vm._s(_vm.worksInfo.score)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "valSpan" }, [
              _vm._v(_vm._s(_vm.worksInfo.score)),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "infoItem" },
        [
          _c("span", { staticClass: "labelSpan" }, [_vm._v("专业大类：")]),
          _vm._v(" "),
          _c("el-tooltip", { attrs: { placement: "top" } }, [
            _c("div", { attrs: { slot: "content" }, slot: "content" }, [
              _vm._v(_vm._s(_vm.worksInfo.majorName)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "valSpan" }, [
              _vm._v(_vm._s(_vm.worksInfo.majorName)),
            ]),
          ]),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "formTitle" }, [_vm._v("作品")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "entryWorksWarp" },
      _vm._l(_vm.worksInfo.matchWorkContentListVoList, function (item, j) {
        return _c(
          "div",
          { key: j, staticClass: "entryItem" },
          [
            _c("span", { staticClass: "labelSpan" }, [
              _vm._v(_vm._s(item.contentName) + "："),
            ]),
            _vm._v(" "),
            _c(
              "el-row",
              { staticClass: "entryWorks" },
              [
                item.contentFileType === "mp4"
                  ? [
                      _c("video", {
                        attrs: { controls: "", src: item.content },
                      }),
                    ]
                  : item.contentFileType === "url"
                  ? [
                      _c("span", [
                        _c(
                          "a",
                          { attrs: { href: item.content, target: "_blank" } },
                          [_vm._v(_vm._s(item.content))]
                        ),
                      ]),
                    ]
                  : item.contentFileType === "input"
                  ? [
                      _c("span", [
                        _c("a", { attrs: { href: item.content } }, [
                          _vm._v(_vm._s(item.content)),
                        ]),
                      ]),
                    ]
                  : item.contentFileType === "textArea"
                  ? [
                      _c("span", [
                        _c("a", { attrs: { href: item.content } }, [
                          _vm._v(_vm._s(item.content)),
                        ]),
                      ]),
                    ]
                  : item.contentFileType === "jpg"
                  ? [
                      _c("el-image", {
                        attrs: {
                          src: item.content,
                          "preview-src-list": [item.content],
                        },
                      }),
                    ]
                  : item.contentFileType === "pdf" ||
                    item.contentFileType === "xls" ||
                    item.contentFileType === "doc"
                  ? [
                      _c("el-image", {
                        staticStyle: { height: "100%" },
                        attrs: {
                          src: item.viewUrl,
                          "preview-src-list": _vm.photoList,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.getViewList(item.content)
                          },
                        },
                      }),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            item.contentFileType != "textArea" &&
            item.contentFileType != "input" &&
            item.contentFileType != "url"
              ? _c(
                  "el-row",
                  { staticClass: "downLoadBtn" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          icon: "el-icon-download",
                          size: "mini",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.downLoadWorks(item.content)
                          },
                        },
                      },
                      [_vm._v("\n          下载\n        ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }